import { HiShieldCheck } from "react-icons/hi";
import { MdCancel, MdAnalytics } from "react-icons/md";

const data = [
  {
    icon: <HiShieldCheck />,
    heading: "Best interest rates on the market",
    detail:
      "lorem ipsum dolor sit amet consectetur adipisicing elit. Quas voluptatum officiis sit. Quia, quibusdam. Quas voluptatum officiis sit. Quia, quibusdam Quia, quibusdam. Quas voluptatum officiis sit. Quia, quibusdam.",
  },
  {
    icon: <MdCancel />,
    heading: "Prevent Unstable Prices",
    detail:
      "lorem ipsum dolor sit amet consectetur adipisicing elit. Quas voluptatum officiis sit. Quia, quibusdam. Quas voluptatum officiis sit. Quia, quibusdam Quia, quibusdam. Quas voluptatum officiis sit. Quia, quibusdam.",
  },
  {
    icon: <MdAnalytics />,
    heading: "Best Price on Market",
    detail:
      "lorem ipsum dolor sit amet consectetur adipisicing elit. Quas voluptatum officiis sit. Quia, quibusdam. Quas voluptatum officiis sit. Quia, quibusdam Quia, quibusdam. Quas voluptatum officiis sit. Quia, quibusdam.",
  },
];
export default data;
